import React from 'react';

import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Message from 'rc-message';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import { Icon, Intent, Dialog, Button, Callout } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { Container, Row, Col } from 'reactstrap';

import {
  getListChemistry,
  updateOne,
  create,
  deleteOneWithCheck,
} from 'api/lookuplistApi';
import { COLOR } from 'config';
import Spinner from '../Spinner';
import DanhMucItemPanel from '../2_LookuplistitemPanelStack';
import Clearfix from 'components/elements/clearfix';
import Confirm from 'components/elements/confirm-element';

export default class DanhMucPanel extends React.PureComponent {
  state = {
    isLoading: true,
    lookuplistData: [],
  };
  componentWillMount = async () => {
    const res = await getListChemistry();
    this.setState({
      isLoading: false,
    });
    if (res.success) {
      this.setState({
        lookuplistData: res.data, // NOTE  loại bỏ quan huyen
      });
    }
  };

  handleDelete = (_id, referenced) => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      this.ConfirmElm.showConfirm({
        content: 'Bạn có muốn xoá ',
        cb: async (value) => {
          if (value) {
            const res = await deleteOneWithCheck(_id, referenced);
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              this.componentWillMount();
            }
            if (res.error) {
              if (res.countReference) {
                this.ConfirmElm.setState({
                  notHide: true,
                  content: (
                    <Callout intent='danger'>
                      Không thể xoá.
                      <br />
                      Danh mục này đang được {res.countReference} sử dụng.
                    </Callout>
                  ),
                });
              } else Message.error({ content: res.message });
            }
          }
        },
      });
    }
  };

  render() {
    return (
      <div>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        {this.state.isLoading && <Spinner />}
        {!this.state.isLoading && (
          <DataList
            openNewPanel={this.openNewPanel}
            dataList={this.state.lookuplistData}
            componentWillMount={this.componentWillMount}
            handleDelete={this.handleDelete}
          />
        )}
      </div>
    );
  }

  openNewPanel = (lookuplist) => {
    const panelNumber = this.props.panelNumber + 1;
    this.props.openPanel({
      component: DanhMucItemPanel,
      props: {
        panelNumber,
        lookuplistId: lookuplist._id,
        LookupListID: lookuplist.LookupListID,
        IsHasExtra: lookuplist.IsHasExtra,
        IsHasChildren: lookuplist.IsHasChildren,
        referenced: lookuplist.referenced,
      },
      title: lookuplist.Name,
    });
  };
}

class DataList extends React.Component {
  static propTypes = {
    dataList: PropTypes.array.isRequired,
    handleEditData: PropTypes.func,
    openNewPanel: PropTypes.func.isRequired,
  };

  state = {
    isOpen: false,
    isLoading: false,
    moreInfo: {
      id: null,
      data: [],
    },
  };

  cellEdit = {
    mode: 'dbclick',
  };

  handleOpen = (row) => {
    this.setState({
      isOpen: true,
      moreInfo: {
        id: row._id,
        data: row.moreInfo,
      },
    });
  };

  handleClose = () => {
    this.setState({
      isOpen: false,
      moreInfo: null,
    });
  };

  handleTableChange = async (type, { cellEdit, data }) => {
    const { newValue, dataField } = cellEdit;
    this.setState({
      isLoading: true,
    });
    const dataTemp = _.map(data, (item) => {
      if (item.key === cellEdit.rowId) {
        item[dataField] = newValue;
        return item;
      } else {
        return item;
      }
    });
    const res = await updateOne(this.state.moreInfo.id, {
      moreInfo: dataTemp,
    });
    if (res.success) {
      if (this.props.componentWillMount) {
        this.props.componentWillMount();
      }
      this.setState({
        isLoading: false,
        moreInfo: {
          id: this.state.moreInfo.id,
          data: dataTemp,
        },
      });
    }

  };

  handleAddItem = async () => {
    this.setState({
      isLoading: true,
    });
    let data = _.get(this.state, 'moreInfo.data', []);
    const item = {
      key: uuidv4(),
      name: 'Tên thuộc tính',
    };
    data = [item, ...data];
    this.setState({
      moreInfo: {
        id: this.state.moreInfo.id,
        data: [...data],
      },
    });
    const res = await updateOne(this.state.moreInfo.id, {
      moreInfo: data,
    });
    if (res.success) {
      this.setState({
        isLoading: false,
      });
      if (this.props.componentWillMount) {
        this.props.componentWillMount();
      }
    } else Message.error({ content: res.message });
  };

  handleDelete = async (record) => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      this.ConfirmElm.showConfirm({
        content: 'Bạn có muốn xoá ',
        cb: async (value) => {
          if (value) {
            this.setState({
              isLoading: true,
            });
            let data = _.get(this.state, 'moreInfo.data', []);
            _.remove(data, (item) => {
              return item.key === record.key;
            });

            const res = await updateOne(this.state.moreInfo.id, {
              moreInfo: data,
            });
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              this.setState({
                isLoading: false,
                moreInfo: {
                  id: this.state.moreInfo.id,
                  data,
                },
              });
            } else {
              if (res.countReference) {
                this.ConfirmElm.setState({
                  notHide: true,
                  content: (
                    <Callout intent='danger'>
                      Không thể xoá.
                      <br />
                      Danh mục này đang được {res.countReference} sử dụng.
                    </Callout>
                  ),
                });
              } else Message.error({ content: res.message });
            }
          }
        },
      });
    }
  };

  handleAddDanhMucHoaChat = async () => {
    const res = await create({
      LookupListID: uuidv4(),
      Name: 'Tên loại chất thải',
      NameEnglish: 'Tên loại chất thải',
      Type: 'HoaChat',
      IsInUse: true,
      DisplaySequence: 0,
      moreInfo: [
        {
          key: uuidv4(),
          name: 'Tên thuộc tính',
        },
      ],
      referenced: {
        collection: 'environmentProtectionWorks',
        path: 'Chemistries.chemistryType',
      },
    });

    if (res.success) {
      if (this.props.componentWillMount) {
        this.props.componentWillMount();
      }
    } else Message.error({ content: res.message });
  };

  renderAdd() {
    if (document.getElementsByClassName('bp3-panel-stack-header')[0])
      return ReactDOM.createPortal(
        <Button
          onClick={this.handleAddDanhMucHoaChat}
          icon='add'
          className='bp3-intent-success'
          style={{ color: COLOR.TEXT_COLOR, backgroundColor: COLOR.SUCCESS }}
        >
          Thêm mới
        </Button>,
        document.getElementsByClassName('bp3-panel-stack-header')[0]
      );
    else return <div />;
  }

  handleTableChangeDanhMuc = async (type, { cellEdit, data }) => {
    const { rowId, dataField, newValue } = cellEdit;
    const res = await updateOne(rowId, {
      [dataField]: newValue,
    });

    if (res.success) {
      if (this.props.componentWillMount) {
        this.props.componentWillMount();
      }
    }
  };

  render() {
    const data = _.get(this.state, 'moreInfo.data', []);
    // console.log(data, '--data--');
    return (
      <React.Fragment>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        <BootstrapTable
          remote={{ cellEdit: true }}
          keyField='_id'
          data={this.props.dataList}
          columns={[
            {
              dataField: 'Name',
              text: 'Tên',
              formatter: (cell, row) => {
                return (
                  <a
                    href='_'
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.openNewPanel(row);
                    }}
                    style={{ color: COLOR.SUCCESS }}
                  >
                    {cell}
                  </a>
                );
              },
            },
            {
              dataField: 'DisplaySequence',
              text: 'Thứ tự',
              style: {
                width: 200,
              },
            },
            {
              dataField: 'key',
              text: '',
              style: { width: 200 },
              formatter: (cell, row) => {
                return (
                  <div
                    style={{
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                    onClick={() => this.handleOpen(row)}
                  >
                    <div>
                      <Icon
                        style={{ height: '100%', color: COLOR.SUCCESS }}
                        icon={IconNames.PROPERTY}
                        intent={Intent.SUCCESS}
                      />
                    </div>
                    <div style={{ paddingLeft: 4 }}>
                      <span>Thuộc tính</span>
                    </div>
                  </div>
                );
              },
            },
            {
              dataField: '_id',
              text: '',
              style: { width: 20 },
              formatter: (cell, row) => {
                return (
                  <Icon
                    style={{ cursor: 'pointer' }}
                    icon={IconNames.DISABLE}
                    iconSize={Icon.SIZE_LARGE}
                    intent={Intent.DANGER}
                    onClick={() => {
                      if (this.props.handleDelete)
                        this.props.handleDelete(cell, row.referenced);
                    }}
                  />
                );
              },
            },
          ]}
          onTableChange={this.handleTableChangeDanhMuc}
          cellEdit={cellEditFactory(this.cellEdit)}
        />
        {this.renderAdd()}
        <Dialog
          style={{ background: 'white' }}
          icon='info-sign'
          onClose={this.handleClose}
          title='Cập nhật thuộc tính'
          isOpen={this.state.isOpen}
        >
          <Container>
            <Clearfix height={8} />
            <Row>
              <Col>
                <Button
                  onClick={this.handleAddItem}
                  icon='add'
                  className='bp3-intent-success float-right'
                  style={{ color: COLOR.TEXT_COLOR, backgroundColor: COLOR.SUCCESS }}
                >
                  Thêm mới
                </Button>
              </Col>
            </Row>
            <Clearfix height={8} />
            <Row>
              <Col>
                {this.state.isLoading && (
                  <div style={{ height: 100 }} className='bp3-skeleton' />
                )}
                {!this.state.isLoading && (
                  <BootstrapTable
                    remote={{ cellEdit: true }}
                    keyField='key'
                    data={data}
                    columns={[
                      {
                        dataField: 'name',
                        text: 'Tên thuộc tính',
                        formatter: (cell, row) => {
                          return cell;
                        },
                      },
                      {
                        dataField: 'key',
                        text: '',
                        style: { width: 20 },
                        formatter: (cell, row) => {
                          const count = _.get(this.state, 'moreInfo.data', [])
                            .length;
                          if (count === 1) {
                            return null;
                          }
                          return (
                            <Icon
                              style={{ cursor: 'pointer' }}
                              icon={IconNames.DISABLE}
                              iconSize={Icon.SIZE_LARGE}
                              intent={Intent.DANGER}
                              onClick={() => {
                                this.handleDelete(row);
                              }}
                            />
                          );
                        },
                      },
                    ]}
                    onTableChange={this.handleTableChange}
                    cellEdit={cellEditFactory(this.cellEdit)}
                  />
                )}
              </Col>
            </Row>
          </Container>
        </Dialog>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ManagementContainer/danh-muc-hoa-chat/1_LookuplistPanelStack/index.js